(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fiberlux-film-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gplex-home-film')) {
  customElements.define('gplex-home-film', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.toggle = this.querySelector('[data-film-toggle]');
      this.sound = this.querySelector('[data-film-sound]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.visible = false;
      this.video.muted = true;
      this.video.controls = false;
      this.querySelector('.gplex-film__controls').hidden = false;
      const sync = () => {
        this.dataset.playing = String(!this.video.paused);
        this.dataset.muted = String(this.video.muted);
        this.toggle.setAttribute('aria-label', this.video.paused ? this.dataset.play : this.dataset.pause);
        this.sound.setAttribute('aria-label', this.video.muted ? this.dataset.unmute : this.dataset.mute);
        this.sound.setAttribute('aria-pressed', String(!this.video.muted));
      };
      this.play = () => this.video.play().catch(() => sync());
      this.auto = () => {
        if (!this.visible || document.hidden) { this.video.pause(); return; }
        if (this.dataset.autoplay === 'true' && !this.userPaused && !this.motion.matches && !navigator.connection?.saveData) this.play();
      };
      ['play', 'pause', 'volumechange'].forEach(type => this.video.addEventListener(type, sync, options));
      this.toggle.addEventListener('click', () => {
        if (this.video.paused) { this.userPaused = false; this.play(); }
        else { this.userPaused = true; this.video.pause(); }
      }, options);
      this.sound.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        if (!this.video.muted && this.video.paused) { this.userPaused = false; this.play(); }
      }, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.video.pause(); else this.auto(); }, options);
      document.addEventListener('visibilitychange', this.auto, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.auto(); }, { threshold: 0.15 });
        this.observer.observe(this);
      } else { this.visible = true; this.auto(); }
      sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gplex-pro-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gplex-pro-film')) {
  customElements.define('gplex-pro-film', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.toggle = this.querySelector('[data-film-toggle]');
      this.sound = this.querySelector('[data-film-sound]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.visible = false;
      this.video.muted = true;
      this.video.controls = false;
      this.querySelector('.gplex-pro-film__controls').hidden = false;
      const sync = () => {
        this.dataset.playing = String(!this.video.paused);
        this.dataset.muted = String(this.video.muted);
        this.toggle.setAttribute('aria-label', this.video.paused ? this.dataset.play : this.dataset.pause);
        this.sound.setAttribute('aria-label', this.video.muted ? this.dataset.unmute : this.dataset.mute);
        this.sound.setAttribute('aria-pressed', String(!this.video.muted));
      };
      this.play = () => this.video.play().catch(() => sync());
      this.auto = () => {
        if (!this.visible || document.hidden) { this.video.pause(); return; }
        if (this.dataset.autoplay === 'true' && !this.userPaused && !this.motion.matches && !navigator.connection?.saveData) this.play();
      };
      ['play', 'pause', 'volumechange'].forEach(type => this.video.addEventListener(type, sync, options));
      this.toggle.addEventListener('click', () => {
        if (this.video.paused) { this.userPaused = false; this.play(); }
        else { this.userPaused = true; this.video.pause(); }
      }, options);
      this.sound.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        if (!this.video.muted && this.video.paused) { this.userPaused = false; this.play(); }
      }, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.video.pause(); else this.auto(); }, options);
      document.addEventListener('visibilitychange', this.auto, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.auto(); }, { threshold: 0.15 });
        this.observer.observe(this);
      } else { this.visible = true; this.auto(); }
      sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gplex-shop-tools"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gplex-shop-guide')) {
  customElements.define('gplex-shop-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tabs = [...this.querySelectorAll('[data-gs-tab]')];
      const panels = [...this.querySelectorAll('[data-gs-panel]')];
      const list = this.querySelector('.gs-tabs');
      list.setAttribute('role', 'tablist');
      const select = tab => {
        tabs.forEach(item => {
          item.setAttribute('aria-selected', String(item === tab));
          item.tabIndex = item === tab ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.gsPanel !== tab.dataset.gsTab; });
      };
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = (index + (rtl ? tabs.length - 1 : 1)) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : tabs.length - 1)) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
      panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      this.dataset.ready = 'true';
      select(tabs[0]);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
